<div class="ui-timer">
  <div class="time-block">
    <span>{{state.displayTime}}</span>
  </div>
</div>